// Central content sourced from the "Welcome to Your Becoming" brochure.

export const BRAND = {
  name: "Brighter Tomorrows",
  full: "Brighter Tomorrows Inc.",
  sub: "Holistic Lifestyle Architecture",
  tagline: "Rooted in Legacy, Rising in Light",
  architect: "Noelle Alicia Bronson",
  email: "NOELLE@BRIGHTERTOMORROWS.COMMUNITY",
  instagram: "@BRIGHTER_TOMORROWS",
  instagramUrl: "https://instagram.com/brighter_tomorrows",
};

export const IMAGES = {
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_pdf-pages-10/artifacts/qwxentih_IMG_7126.jpeg",
  hero: "/hero-v3.jpg?v=3",
  architect: "/architect-v15.jpg?v=15",
  interior: "https://images.unsplash.com/photo-1762810548877-63512759805e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxibGFjayUyMHdvbWFuJTIwbWVkaXRhdGluZyUyMGNhbG0lMjB3ZWxsbmVzcyUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3ODQyNDQ0NDN8MA&ixlib=rb-4.1.0&q=85",
  floral: "https://images.unsplash.com/photo-1630330600342-c7c69cb08472?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwYmVpZ2UlMjBmbG9yYWwlMjBhcnJhbmdlbWVudCUyMHdlbGxuZXNzfGVufDB8fHx8MTc4NDIyOTk4OHww&ixlib=rb-4.1.0&q=85",
  candle: "/candle-v2.jpg?v=2",
};

export const REFLECTIONS = [
  "Despite everything I've achieved, I still feel stuck.",
  "I feel like life is always in GO mode.",
  "I pictured my life so differently.",
  "Nothing is really wrong… but nothing feels right either.",
  "Life is good, but my heart wants more.",
  "Is this all there is?",
  "I'm exhausted and successful on paper, but quietly empty inside.",
  "I lost who I am along the way.",
  "I feel lonely, like I'm doing it all by myself.",
  "When is it okay to put me first?",
];

export const PILLARS = [
  { title: "Mindset Mastery", body: "Transform the beliefs that shape your reality." },
  { title: "Habit Architecture", body: "Build rhythms that support the woman you're becoming." },
  { title: "Emotional Resilience", body: "Develop the emotional capacity to navigate life with confidence and peace." },
  { title: "Lifestyle Architecture", body: "Design a life that reflects your values instead of your obligations." },
  { title: "Holistic Integration", body: "Align your mind, body, and spirit so every area works together." },
  { title: "Sustainable Transformation", body: "Create change that lasts because it's built from identity, not willpower." },
];

export const JOURNEY = [
  { n: "01", title: "Meet", body: "Understand where you are and what you're carrying." },
  { n: "02", title: "Validate", body: "Make sense of the experiences, beliefs, and patterns that brought you here." },
  { n: "03", title: "Shift", body: "Challenge old perspectives and create space for something new." },
  { n: "04", title: "Notice", body: "Recognize your patterns as they're happening — not just afterward." },
  { n: "05", title: "Choose", body: "Turn awareness into intentional decisions aligned with who you're becoming." },
  { n: "06", title: "Practice", body: "Introduce small, realistic changes you can actually sustain." },
  { n: "07", title: "Build", body: "Stack those changes until new behaviors begin supporting one another." },
  { n: "08", title: "Become", body: "Allow repeated choices to become evidence, identity, and eventually — a new way of living." },
];

export const STEPS = [
  { n: "01", title: "Set Your Intention", body: "Name the life you're walking toward and anchor to it." },
  { n: "02", title: "Practice Gratitude", body: "Root in what is already abundant and true within you." },
  { n: "03", title: "Honor Your Boundaries", body: "Protect your energy as the sacred resource it is." },
  { n: "04", title: "Trust the Process", body: "Release the timeline and let becoming unfold in its season." },
];

export const TESTIMONIALS = [
  { title: "From Feeling Stuck to Finding Clarity", body: "A truly transformative experience — I finally understood what I was reaching for in my 40s.", author: "Finally Thriving" },
  { title: "Permission to Want More", body: "I moved from exhaustion and feeling empty inside to feeling genuinely alive again.", author: "Working Mother" },
  { title: "Is This All There Is?", body: "I realized it's never too late to change. That single shift rewrote everything.", author: "Executive" },
  { title: "From Overwhelmed to Empowered", body: "I stopped going through the motions and started moving forward with intention.", author: "Entrepreneur" },
  { title: "Rediscovering Myself", body: "I found balance across my roles as mother, wife, and professional — and found me again.", author: "Wife-Mother-Founder" },
  { title: "Learning to Put Me First", body: "For the first time, honoring my own boundaries felt like an act of love, not guilt.", author: "Nonprofit Leader" },
];

export const PACKAGES = [
  {
    id: "renew",
    name: "The Renew Experience",
    duration: "90-Day Intensive",
    price: 2000,
    originalPrice: 4000,
    founding: true,
    monthly: "or split with Klarna & Afterpay",
    cadence: "Weekly coaching",
    focus: "Focused momentum",
    featured: false,
    features: [
      "Discovery session",
      "Personalized wellness plan",
      "Weekly 1:1 coaching calls",
      "Mindfulness resources",
      "Progress celebrations",
    ],
  },
  {
    id: "flourish",
    name: "The Flourish Experience",
    duration: "6-Month Journey",
    price: 2000,
    originalPrice: 4000,
    founding: true,
    monthly: "or split with Klarna & Afterpay",
    cadence: "Bi-weekly coaching",
    focus: "Deep integration",
    featured: true,
    features: [
      "Everything in Renew",
      "Bi-weekly 1:1 coaching calls",
      "The Becoming Collection guide",
      "House of Becoming community access",
      "Legacy & business preparation",
      "Reflection exercises & rituals",
    ],
  },
];

export const INCLUDED = [
  "One-on-one sessions",
  "Personalized transformation plans",
  "Accountability & habit coaching",
  "Mindset reframing",
  "Reflection exercises",
  "The Becoming Collection guide",
  "The House of Becoming community",
];

export const GROUP = {
  id: "group",
  name: "The Gathering",
  subtitle: "A 4-Week Group Circle",
  price: 549,
  capacity: 6,
  schedule: "Four consecutive Sundays · 2–4 PM PST",
  starts: "Next session date TBD based on enrollment",
  blurb:
    "Not quite ready to fully commit to a 90-day or 6-month journey — but still longing for a taste of the Brighter Tomorrows experience? The Gathering is your invitation. An intimate small-group circle of up to six women, moving together through four weekly sessions built on the same signature method. Come as you are, grow in beautiful company, and discover what your becoming can feel like.",
  features: [
    "4 live group sessions (2 hours each)",
    "Guided by Noelle using the signature method",
    "Intimate circle of up to 6 women",
    "Mindfulness & reflection practices",
    "Warm, supportive sisterhood",
  ],
};

export const FAMILIAR = [
  "Successful and capable on the outside — quietly unfulfilled within.",
  "Always caring for everyone else, while your own needs wait at the back of the line.",
  "Disconnected from your own wants, your identity, the things that once lit you up.",
  "You know something needs to change — you just don't know where to begin.",
  "Choosing yourself still arrives wrapped in guilt.",
  "A life built around responsibilities and expectations, instead of intention.",
];

export const HOME_OFFERS = [
  {
    id: "renew",
    name: "Renew",
    tag: "90-Day Private Intensive",
    cadence: "Weekly 1:1 support",
    price: "$4,000",
    desc: "For the woman ready for focused, concentrated transformation and real momentum.",
    cta: "Explore Renew",
    featured: false,
  },
  {
    id: "flourish",
    name: "Flourish",
    tag: "6-Month Private Journey",
    cadence: "Biweekly 1:1 support",
    price: "$4,000",
    desc: "For the woman who wants transformation with time to integrate and sustain lasting lifestyle change.",
    cta: "Explore Flourish",
    featured: true,
  },
  {
    id: "gathering",
    name: "The Gathering",
    tag: "4-Week Small Group Experience",
    cadence: "An intimate circle of up to six women",
    price: "$549",
    desc: "An intimate introduction to the Brighter Tomorrows experience, through the warmth of community.",
    note: "Join the priority list for the next Gathering.",
    cta: "Join the Priority List",
    featured: false,
    waitlist: true,
  },
];

export const HOME_FAQS = [
  { q: "How do I know which experience is right for me?", a: "That's exactly what your complimentary discovery call is for. We'll talk through where you are and what you need, and together choose between Renew, Flourish, or The Gathering — with zero pressure." },
  { q: "Is this therapy?", a: "No. This is goal-focused holistic coaching, not therapy. We focus on vision, intention, boundaries, and forward movement — designing the life you want rather than diagnosing the past." },
  { q: "What happens during our sessions?", a: "Each session is a spacious, private 1:1 conversation (about 50 minutes) where we set intentions, move through what's in the way, and build the mindset, habits, and rhythms that reflect who you're becoming." },
  { q: "What if my schedule changes?", a: "Life happens. Sessions are flexible and rescheduled with grace — you move at your own pace, and there's room built in for real life." },
  { q: "When can I expect to notice change?", a: "Many women feel a meaningful shift after the very first session. Deeper, lasting change builds steadily over the weeks and months as new patterns take root." },
  { q: "Are payment options available?", a: "Yes. You can pay in full, or split your investment into interest-free payments with Klarna or Afterpay at checkout." },
  { q: "What happens after I book?", a: "After you reach out, Noelle follows up personally to schedule your discovery call. From there we choose your experience and begin — no overwhelm, just a clear next step." },
];

export const FAQS = [
  { q: "How long does each session last?", a: "Each coaching session runs approximately 50 minutes — spacious enough to go deep, focused enough to move forward." },
  { q: "Do I need to have it all figured out?", a: "Not at all. Willingness is enough. You bring the openness; we'll shape the clarity together." },
  { q: "How soon will I see results?", a: "Many clients feel a meaningful shift after the very first session, with lasting change building over time." },
  { q: "How often will we meet?", a: "Weekly or bi-weekly, depending on the experience you choose and the rhythm that serves you best." },
  { q: "What if life gets busy or I fall behind?", a: "You grow at your own pace. There's grace built into this work — we meet you exactly where you are." },
  { q: "Is this coaching or therapy?", a: "This is goal-focused holistic coaching, not therapy. We focus on vision, intention, and forward movement." },
];
